import React from "react";
import { BsTwitter, BsLinkedin, BsGithub } from "react-icons/bs";
const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a
          href={process.env.REACT_APP_LINKEDIN}
          alt="Linkedin"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a
          href={process.env.REACT_APP_TWITTER}
          alt="Twitter"
          target="_blank"
          rel="noreferrer"
        >
          <BsTwitter />
        </a>
      </div>
      <div>
        <a
          href={process.env.REACT_APP_GITHUB}
          alt="Github"
          target="_blank"
          rel="noreferrer"
        >
          <BsGithub />
        </a>
      </div>
      {/* <div>
        <BsInstagram />
      </div> */}
    </div>
  );
};

export default SocialMedia;
